import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import toPairs from 'lodash/toPairs';
import groupBy from 'lodash/groupBy';

import { groupCollection } from '@sp/utils/collection';

import ServicesGroup from './ServicesGroup';

import { formatMileage } from '../../utils';

import s from './styles.less';

const servicePropTypes = {
  expectedDate: PropTypes.string,
  expectedMileage: PropTypes.number,
};

const propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  services: PropTypes.arrayOf(PropTypes.shape(servicePropTypes)).isRequired,
  // not defined in more details due to 'dynamic' fields generation
  groupedServices: PropTypes.object,
};
const defaultProps = {};

const ServicesGroupList = ({ groupedServices }) => (
  <div className={s.services}>
    {toPairs(groupedServices).map(
      ([groupName, services]) =>
        services &&
        services.length && (
          <ServicesGroup
            key={groupName}
            name={groupName}
            services={services.map(({ expectedMileage, ...service }) => ({
              ...service,
              expectedMileage:
                expectedMileage && formatMileage(expectedMileage),
            }))}
          />
        ),
    )}
  </div>
);

ServicesGroupList.propTypes = propTypes;
ServicesGroupList.defaultProps = defaultProps;

export default compose(
  withProps(({ services = [] }) => {
    const fullServiceType = 'Full Service';
    const interimType = 'Interim Service';
    const motType = 'MOT';

    const groupedServices = groupCollection(services, {
      [fullServiceType]: ({ isService, type }) =>
        isService && type !== interimType,
      [interimType]: ({ type }) => type === interimType,
      [motType]: ({ type }) => type === motType,
    });

    return {
      groupedServices: {
        [fullServiceType]: groupedServices[fullServiceType],
        [interimType]: groupedServices[interimType],
        ...groupBy(groupedServices.other, 'type'),
        [motType]: groupedServices[motType],
      },
    };
  }),
)(ServicesGroupList);
